// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  padding-bottom: 50px;
  font-family: Helvetica, Arial, sans-serif;
}

.app {
  height: 100vh;
}

#Democratic,
#Independent-Democratic,
#Republican {
  margin-bottom: 20px;
}

.navbar {
  padding: 10px 5% 0 5%;
}

.nav-title-container {
  padding-top: 15px;
  padding-bottom: 15px;
  display: flex;
  align-items: center;
  max-height: 100px;
}

.download-tooltip>.tooltip-inner {
  background-color: #fff;
  color: RGB(51, 51, 51);
  border: 0.8px solid RGB(169, 169, 169);
}

.download-tooltip>.tooltip-arrow {
  border-top: 5px solid RGB(169, 169, 169) !important;
}

a {
  color: black;
  text-decoration: none;
}

a:link,
a:visited,
a:hover,
a:active {
  color: black;
  outline: 0;
  word-wrap: break-word;
}

hr {
  margin-top: 0px;
  margin-bottom: 0px;
  border-top: 1px solid #eee;
  /* width: 110%; */
}

.row-centered {
  text-align: center;
}

.row-right {
  padding-right: 20px;
}

.col-horizontal {
  display: inline-flex;
}

.nav-logo {
  display: inline-block;
  width: 65px;
  height: 75px;
  padding-bottom: 10px;
}

.nav-title {
  display: inline-block;
  padding-left: 20px;
  padding-bottom: 6px;
  overflow: hidden;
}

.nav-home-link {
  display: inline;
  padding: 0;
}

.ai-title-container {
  display: inline;
  margin-top: 15px;
  font-family: 'Zilla Slab', serif;
  font-size: 26px;
  color: #fff;
  letter-spacing: 1.5px;
  overflow-wrap: break-word;
  padding: 0 20px;
}

@media (max-width: 576px) {
  .ai-title-container {
    font-size: 16px;
    margin-bottom: 5px;
  }
}

.senate-title {
  font-size: 20px;
  margin-bottom: 15px;
}

.filter-buttons {
  display: inline;
  padding-right: 20px;
}

.view-button {
  padding-bottom: 15px;
}

.Select {
  position: relative;
  display: inline-block;
  padding-right: 15px;
  width: 30%;
}

@media (max-width: 715px) {
  .Select {
    min-width: 50%;
  }
}

.houses {
  margin-top: 10px;
  padding-top: 100px;
}


.legislative-view-col {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.legislative-view-col .house-detail-title {
  margin-top: 15px;
}

@media (min-width: 576px) {
  .houses {
    padding-top: 120px;
  }
}


@media (min-width: 768px) {}

@media (min-width: 992px) {
  .houses {
    padding-top: 160px;
  }

  .legislative-view-col .house-detail-title {
    margin: 30px 0;
  }

}

@media (min-width: 1200px) {

  .legislative-view-col .house-detail-title {
    margin: 40px 0;
  }

}

@media (min-width: 1400px) {}


.house-components {
  /* width: 100%;
  min-height: 400px; */
  padding: 5%;
  padding-top: 20px;
}

.house-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 20px;
}

.house-detail-title {
  padding-top: 15px;
  min-height: 60px;
  float: inline-end;
}

.house-detail-data {
  position: relative;
  bottom: 0;
  left: 0;
}

.btn-circle {
  width: 60px;
  height: 60px;
  padding: 6px 0;
  margin: 1.5px;
  word-wrap: normal;
  font-size: 10px;
  color: #000000;
  line-height: 1.33;
  border-radius: 50%;
  border-style: none;
  transition: opacity 1.5s ease-in;
  hyphens: auto;
  overflow-wrap: break-word;
}

.btn-row {
  padding-top: 15px;
  padding-bottom: 15px;
}

.btn-circle:hover {
  box-shadow: 0 12px 16px 0 rgba(0, 0, 0, 0.2),
    0 17px 50px 0 rgba(0, 0, 0, 0.19);
}

button:visited {
  outline: none;
  border: none;
}

button:focus {
  outline: none;
}

.modal-bold {
  font-weight: bold;
  font-size: 15px;
  color: rgb(0, 0, 0);
}

.modal-image {
  border-radius: 5%;
  width: 100px;
  height: 100px;
  display: block;
  margin: auto;
}

.district-image {
  border-radius: 5%;
  width: 100px;
  height: 100px;
  display: block;
  margin: auto;
}

.modal-header-col {
  display: inline;
  margin-right: 5px;
}

.person-container .modal-content .modal-header {
  align-items: initial;
}

.person-info {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.person-title-info h5 {
  color: rgb(108, 108, 108);
  font-weight: bold;
}


.party-title {
  color: rgb(108, 108, 108);
}

.full-name-title {
  color: rgb(0, 0, 0);
  font-weight: bold;
}

.unbold-text {
  font-weight: lighter;
}

.district-title {
  font-weight: bold;
  margin-left: 15px;
}

.district-num {
  font-weight: bold;
}

.region-title {
  font-weight: bold;
}

.borough-title {
  font-weight: bold;
}

.office-title {
  text-decoration: underline;
}

.personal-staff {
  margin-left: -15px
}

/*     Colors    */
.arab-asian-democratic {
  background: #BED3EE;
}

.arab-asian-black-democratic {
  background: linear-gradient(-45deg, #BED3EE 50%, #71B2E2 50%);
}

.arab-asian-white-democratic {
  background: linear-gradient(-45deg, #BED3EE 50%, #304D92 50%);
}

.arab-asian-latine-democratic {
  background: linear-gradient(-45deg, #BED3EE 50%, #2C8A9E 50%);
}

.black-democratic {
  background-color: #71B2E2;
}

.black-latine-democratic {
  background: linear-gradient(-45deg, #2C8A9E 50%, #71B2E2 50%);
}

.black-white-democratic {
  background: linear-gradient(-45deg, #71B2E2 50%, #304D92 50%);
}

.black-latine-white-democratic {
  background: linear-gradient(-45deg, #304D92 38%, #2C8A9E 38%, #2C8A9E 62%, #71B2E2 62%);
}

.latine-democratic {
  background-color: #2C8A9E;
}

.latine-white-democratic {
  background: linear-gradient(-45deg, #304D92 50%, #2C8A9E 50%);
}

.white-democratic {
  background-color: #304D92;
}

.arab-asian-republican {
  background-color: #FACDD9;
}

.arab-asian-black-republican {
  background: linear-gradient(-45deg, #FACDD9 50%, #F27BAA 50%);
}

.arab-asian-latine-republican {
  background: linear-gradient(-45deg, #FACDD9 50%, #A95688 50%);
}

.black-republican {
  background-color: #F27BAA;
}


.black-white-republican {
  background: linear-gradient(-45deg, #F27BAA 50%, #DA3248 50%);
}

.latine-republican {
  background-color: #A95688;
}

.latine-white-republican {
  background: linear-gradient(-45deg, #A95688 50%, #DA3248 50%);
}

.white-republican {
  background-color: #DA3248;
}

.white-conservative {
  background-color: #F79646;
}

.white-independent {
  background-color: #8165A3;
}

.unknown, .unknown-democratic, .unknown-republican, .unknown-independent {
  background-color: rgb(69, 69, 69);
}

.undecided {
  background-color: #AEB7B6;
  color: #AEB7B6;
}

.white-text {
  color: #FFFFFF
}

.black-text {
  color: #000000;
}

.round-button {
  width: 13.5px;
  height: 13.5px;
  display: table-cell;
  padding-bottom: 1px;
}

.round-button-circle {
  padding-bottom: 100%;
  border-radius: 50%;
  overflow: hidden;
}

.round-button-outline {
  padding-bottom: 50%;
  border-radius: 50%;
  overflow: hidden;
  border-style: solid;
  border-width: 3px;
}

.chair-outline {
  border-style: solid !important;
  border-color: black;
  border-width: 4px;
}

.legend {
  float: left;
}

.legend-lbl {
  padding-bottom: 8px;
}

.lblname {
  display: table-cell;
  padding: 0 5px;
  vertical-align: middle;
  font-weight: 0;
}

.button-container {
  margin-bottom: 15px;
  margin-top: 5px;
}

.navbar-default {
  background-color: #1976d2 !important;
  background-image: none !important;
  color: white !important;
  font-family: 'Lato', sans-serif;
  letter-spacing: 1px;
}

.navbar-toggle {
  float: left;
  margin-left: 10px;
  margin-bottom: 10px;
  margin-top: 0px;
}

.navbar-default .navbar-nav>.active>a,
.navbar-default .navbar-nav>.active>a:visited,
.navbar-default .navbar-nav>.active>a:hover,
.navbar-default .navbar-nav>.active>a:active,
.navbar-default .navbar-nav>.active>a:focus {
  color: white;
  background-image: none;
}

.navbar-default .navbar-nav>li>a,
.navbar-default .navbar-nav>li>a:visited,
.navbar-default .navbar-nav>li>a:hover {
  background-color: #1976d2 !important;
  color: white !important;
}

nav {
  background-color: #1976d2;

}

.dropdown-menu {
  padding: 0;
}

.dropdown-menu .divider {
  margin: 0;
}

.dropdown-menu>li>a {
  padding: 9px 20px;
  color: black;
}

.dropdown-menu>li>a:hover {
  color: white;
  background-color: black !important;
  background-image: none;
}

.dropdown-menu>.active>a,
.dropdown-menu>.active>a:focus,
.dropdown-menu>.active>a:hover {
  background-image: none;
  background-color: #1976d2;
  color: white;
}

@media (max-width: 767px) {

  .navbar .navbar-nav .open .dropdown-menu>.active>a,
  .navbar .navbar-nav .open .dropdown-menu>.active>a:hover {
    background-image: none;
    background-color: #dbdbdb;
    color: white;
  }

  .navbar-default .navbar-nav .open .dropdown-menu>li>a {
    color: white;
  }
}

.nav .open>a,
.nav .open>a:focus,
.nav .open>a:hover {
  border-color: #e7e7e7;
}



.navbar-default .navbar-nav>.open>a,
.navbar-default .navbar-nav>.open>a:focus {
  background-color: #fff;
  background-image: none;
  color: white;
}

.navbar-default .navbar-nav>.open>a:visited {
  color: white;
}


.my-modal {
  width: 50vw;
}

@media (max-width: 768px) {
  .my-modal {
    width: 80vw;
  }
}

.staff-col {
  margin-right: 20px;
}

.modal-footer {
  text-align: left;
}

.modal-close-btn {
  text-align: right;
}

.spinner {
  position: absolute;
  margin-left: 45%;
  margin-top: 20%;
}

@media (max-width: 768px) {
  .spinner {
    margin-top: 50%;
  }
}

.loading-overlay {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
}

.not-loading {
  display: none;
}

.error-message {
  color: black;
}

.error-message.modal-dialog {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
}

.error-message .modal-content {
  height: auto;
  min-height: 100%;
  border: 0 none;
  border-radius: 0;
  box-shadow: none;
}


.social-container {
  display: flex;
  flex-direction: column;
}

.social-media {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.social-text {
  padding-left: 5px;
}


.hide-error {
  display: none !important;
}

.modal-open {
  overflow: scroll !important;

}

@media (max-width: 576px) {
  .modal-image {
    width: 60px;
    height: 60px;

  }

  .district-image {
    width: 60px;
    height: 60px;
  }
}

.footer {
  background-color: #1976d2;
  color: white;
  text-align: center;
  padding: 20px;
}

.footer a {
  color: white;
  padding: 10px;
  margin: 10px;
}

.footer a:hover {
  text-decoration: underline;
  text-decoration-color: black;
}

.vr {
  color: black;
  opacity: 1;
}

.copyright {
  padding-top: 10px;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,oBAAoB;EACpB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;AACf;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,sCAAsC;AACxC;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,YAAY;EACZ,qBAAqB;AACvB;;AAEA;;;;EAIE,YAAY;EACZ,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,WAAW;EACX,qBAAqB;EACrB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE;IACE,eAAe;IACf,kBAAkB;EACpB;AACF;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;;AAGA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;;AAGA,2BAA2B;;AAE3B;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,cAAc;EAChB;;AAEF;;AAEA;;EAEE;IACE,cAAc;EAChB;;AAEF;;AAEA,4BAA4B;;;AAG5B;EACE;sBACoB;EACpB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;AACT;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,aAAa;EACb,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,gCAAgC;EAChC,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE;qCACmC;AACrC;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,cAAc;EACd,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,cAAc;EACd,YAAY;AACd;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;;AAGA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE;AACF;;AAEA,kBAAkB;AAClB;EACE,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,uFAAuF;AACzF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA;EACE,6DAA6D;AAC/D;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE;AACF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,iCAAiC;EACjC,uBAAuB;EACvB,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;;;;EAKE,YAAY;EACZ,sBAAsB;AACxB;;AAEA;;;EAGE,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;;AAE3B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;;;EAGE,sBAAsB;EACtB,yBAAyB;EACzB,YAAY;AACd;;AAEA;;EAEE;;IAEE,sBAAsB;IACtB,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;;;EAGE,qBAAqB;AACvB;;;;AAIA;;EAEE,sBAAsB;EACtB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;;AAGA;EACE,WAAW;AACb;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;AACtC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;;AAGA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;;AAGA;EACE,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;;AAE7B;;AAEA;EACE;IACE,WAAW;IACX,YAAY;;EAEd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,iBAAiB;AACnB","sourcesContent":["body {\n  margin: 0;\n  padding-bottom: 50px;\n  font-family: Helvetica, Arial, sans-serif;\n}\n\n.app {\n  height: 100vh;\n}\n\n#Democratic,\n#Independent-Democratic,\n#Republican {\n  margin-bottom: 20px;\n}\n\n.navbar {\n  padding: 10px 5% 0 5%;\n}\n\n.nav-title-container {\n  padding-top: 15px;\n  padding-bottom: 15px;\n  display: flex;\n  align-items: center;\n  max-height: 100px;\n}\n\n.download-tooltip>.tooltip-inner {\n  background-color: #fff;\n  color: RGB(51, 51, 51);\n  border: 0.8px solid RGB(169, 169, 169);\n}\n\n.download-tooltip>.tooltip-arrow {\n  border-top: 5px solid RGB(169, 169, 169) !important;\n}\n\na {\n  color: black;\n  text-decoration: none;\n}\n\na:link,\na:visited,\na:hover,\na:active {\n  color: black;\n  outline: 0;\n  word-wrap: break-word;\n}\n\nhr {\n  margin-top: 0px;\n  margin-bottom: 0px;\n  border-top: 1px solid #eee;\n  /* width: 110%; */\n}\n\n.row-centered {\n  text-align: center;\n}\n\n.row-right {\n  padding-right: 20px;\n}\n\n.col-horizontal {\n  display: inline-flex;\n}\n\n.nav-logo {\n  display: inline-block;\n  width: 65px;\n  height: 75px;\n  padding-bottom: 10px;\n}\n\n.nav-title {\n  display: inline-block;\n  padding-left: 20px;\n  padding-bottom: 6px;\n  overflow: hidden;\n}\n\n.nav-home-link {\n  display: inline;\n  padding: 0;\n}\n\n.ai-title-container {\n  display: inline;\n  margin-top: 15px;\n  font-family: 'Zilla Slab', serif;\n  font-size: 26px;\n  color: #fff;\n  letter-spacing: 1.5px;\n  overflow-wrap: break-word;\n  padding: 0 20px;\n}\n\n@media (max-width: 576px) {\n  .ai-title-container {\n    font-size: 16px;\n    margin-bottom: 5px;\n  }\n}\n\n.senate-title {\n  font-size: 20px;\n  margin-bottom: 15px;\n}\n\n.filter-buttons {\n  display: inline;\n  padding-right: 20px;\n}\n\n.view-button {\n  padding-bottom: 15px;\n}\n\n.Select {\n  position: relative;\n  display: inline-block;\n  padding-right: 15px;\n  width: 30%;\n}\n\n@media (max-width: 715px) {\n  .Select {\n    min-width: 50%;\n  }\n}\n\n.houses {\n  margin-top: 10px;\n  padding-top: 100px;\n}\n\n\n.legislative-view-col {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.legislative-view-col .house-detail-title {\n  margin-top: 15px;\n}\n\n@media (min-width: 576px) {\n  .houses {\n    padding-top: 120px;\n  }\n}\n\n\n@media (min-width: 768px) {}\n\n@media (min-width: 992px) {\n  .houses {\n    padding-top: 160px;\n  }\n\n  .legislative-view-col .house-detail-title {\n    margin: 30px 0;\n  }\n\n}\n\n@media (min-width: 1200px) {\n\n  .legislative-view-col .house-detail-title {\n    margin: 40px 0;\n  }\n\n}\n\n@media (min-width: 1400px) {}\n\n\n.house-components {\n  /* width: 100%;\n  min-height: 400px; */\n  padding: 5%;\n  padding-top: 20px;\n}\n\n.house-buttons {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin-top: 20px;\n}\n\n.house-detail-title {\n  padding-top: 15px;\n  min-height: 60px;\n  float: inline-end;\n}\n\n.house-detail-data {\n  position: relative;\n  bottom: 0;\n  left: 0;\n}\n\n.btn-circle {\n  width: 60px;\n  height: 60px;\n  padding: 6px 0;\n  margin: 1.5px;\n  word-wrap: normal;\n  font-size: 10px;\n  color: #000000;\n  line-height: 1.33;\n  border-radius: 50%;\n  border-style: none;\n  transition: opacity 1.5s ease-in;\n  hyphens: auto;\n  overflow-wrap: break-word;\n}\n\n.btn-row {\n  padding-top: 15px;\n  padding-bottom: 15px;\n}\n\n.btn-circle:hover {\n  box-shadow: 0 12px 16px 0 rgba(0, 0, 0, 0.2),\n    0 17px 50px 0 rgba(0, 0, 0, 0.19);\n}\n\nbutton:visited {\n  outline: none;\n  border: none;\n}\n\nbutton:focus {\n  outline: none;\n}\n\n.modal-bold {\n  font-weight: bold;\n  font-size: 15px;\n  color: rgb(0, 0, 0);\n}\n\n.modal-image {\n  border-radius: 5%;\n  width: 100px;\n  height: 100px;\n  display: block;\n  margin: auto;\n}\n\n.district-image {\n  border-radius: 5%;\n  width: 100px;\n  height: 100px;\n  display: block;\n  margin: auto;\n}\n\n.modal-header-col {\n  display: inline;\n  margin-right: 5px;\n}\n\n.person-container .modal-content .modal-header {\n  align-items: initial;\n}\n\n.person-info {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.person-title-info h5 {\n  color: rgb(108, 108, 108);\n  font-weight: bold;\n}\n\n\n.party-title {\n  color: rgb(108, 108, 108);\n}\n\n.full-name-title {\n  color: rgb(0, 0, 0);\n  font-weight: bold;\n}\n\n.unbold-text {\n  font-weight: lighter;\n}\n\n.district-title {\n  font-weight: bold;\n  margin-left: 15px;\n}\n\n.district-num {\n  font-weight: bold;\n}\n\n.region-title {\n  font-weight: bold;\n}\n\n.borough-title {\n  font-weight: bold;\n}\n\n.office-title {\n  text-decoration: underline;\n}\n\n.personal-staff {\n  margin-left: -15px\n}\n\n/*     Colors    */\n.arab-asian-democratic {\n  background: #BED3EE;\n}\n\n.arab-asian-black-democratic {\n  background: linear-gradient(-45deg, #BED3EE 50%, #71B2E2 50%);\n}\n\n.arab-asian-white-democratic {\n  background: linear-gradient(-45deg, #BED3EE 50%, #304D92 50%);\n}\n\n.arab-asian-latine-democratic {\n  background: linear-gradient(-45deg, #BED3EE 50%, #2C8A9E 50%);\n}\n\n.black-democratic {\n  background-color: #71B2E2;\n}\n\n.black-latine-democratic {\n  background: linear-gradient(-45deg, #2C8A9E 50%, #71B2E2 50%);\n}\n\n.black-white-democratic {\n  background: linear-gradient(-45deg, #71B2E2 50%, #304D92 50%);\n}\n\n.black-latine-white-democratic {\n  background: linear-gradient(-45deg, #304D92 38%, #2C8A9E 38%, #2C8A9E 62%, #71B2E2 62%);\n}\n\n.latine-democratic {\n  background-color: #2C8A9E;\n}\n\n.latine-white-democratic {\n  background: linear-gradient(-45deg, #304D92 50%, #2C8A9E 50%);\n}\n\n.white-democratic {\n  background-color: #304D92;\n}\n\n.arab-asian-republican {\n  background-color: #FACDD9;\n}\n\n.arab-asian-black-republican {\n  background: linear-gradient(-45deg, #FACDD9 50%, #F27BAA 50%);\n}\n\n.arab-asian-latine-republican {\n  background: linear-gradient(-45deg, #FACDD9 50%, #A95688 50%);\n}\n\n.black-republican {\n  background-color: #F27BAA;\n}\n\n\n.black-white-republican {\n  background: linear-gradient(-45deg, #F27BAA 50%, #DA3248 50%);\n}\n\n.latine-republican {\n  background-color: #A95688;\n}\n\n.latine-white-republican {\n  background: linear-gradient(-45deg, #A95688 50%, #DA3248 50%);\n}\n\n.white-republican {\n  background-color: #DA3248;\n}\n\n.white-conservative {\n  background-color: #F79646;\n}\n\n.white-independent {\n  background-color: #8165A3;\n}\n\n.unknown, .unknown-democratic, .unknown-republican, .unknown-independent {\n  background-color: rgb(69, 69, 69);\n}\n\n.undecided {\n  background-color: #AEB7B6;\n  color: #AEB7B6;\n}\n\n.white-text {\n  color: #FFFFFF\n}\n\n.black-text {\n  color: #000000;\n}\n\n.round-button {\n  width: 13.5px;\n  height: 13.5px;\n  display: table-cell;\n  padding-bottom: 1px;\n}\n\n.round-button-circle {\n  padding-bottom: 100%;\n  border-radius: 50%;\n  overflow: hidden;\n}\n\n.round-button-outline {\n  padding-bottom: 50%;\n  border-radius: 50%;\n  overflow: hidden;\n  border-style: solid;\n  border-width: 3px;\n}\n\n.chair-outline {\n  border-style: solid !important;\n  border-color: black;\n  border-width: 4px;\n}\n\n.legend {\n  float: left;\n}\n\n.legend-lbl {\n  padding-bottom: 8px;\n}\n\n.lblname {\n  display: table-cell;\n  padding: 0 5px;\n  vertical-align: middle;\n  font-weight: 0;\n}\n\n.button-container {\n  margin-bottom: 15px;\n  margin-top: 5px;\n}\n\n.navbar-default {\n  background-color: #1976d2 !important;\n  background-image: none !important;\n  color: white !important;\n  font-family: 'Lato', sans-serif;\n  letter-spacing: 1px;\n}\n\n.navbar-toggle {\n  float: left;\n  margin-left: 10px;\n  margin-bottom: 10px;\n  margin-top: 0px;\n}\n\n.navbar-default .navbar-nav>.active>a,\n.navbar-default .navbar-nav>.active>a:visited,\n.navbar-default .navbar-nav>.active>a:hover,\n.navbar-default .navbar-nav>.active>a:active,\n.navbar-default .navbar-nav>.active>a:focus {\n  color: white;\n  background-image: none;\n}\n\n.navbar-default .navbar-nav>li>a,\n.navbar-default .navbar-nav>li>a:visited,\n.navbar-default .navbar-nav>li>a:hover {\n  background-color: #1976d2 !important;\n  color: white !important;\n}\n\nnav {\n  background-color: #1976d2;\n\n}\n\n.dropdown-menu {\n  padding: 0;\n}\n\n.dropdown-menu .divider {\n  margin: 0;\n}\n\n.dropdown-menu>li>a {\n  padding: 9px 20px;\n  color: black;\n}\n\n.dropdown-menu>li>a:hover {\n  color: white;\n  background-color: black !important;\n  background-image: none;\n}\n\n.dropdown-menu>.active>a,\n.dropdown-menu>.active>a:focus,\n.dropdown-menu>.active>a:hover {\n  background-image: none;\n  background-color: #1976d2;\n  color: white;\n}\n\n@media (max-width: 767px) {\n\n  .navbar .navbar-nav .open .dropdown-menu>.active>a,\n  .navbar .navbar-nav .open .dropdown-menu>.active>a:hover {\n    background-image: none;\n    background-color: #dbdbdb;\n    color: white;\n  }\n\n  .navbar-default .navbar-nav .open .dropdown-menu>li>a {\n    color: white;\n  }\n}\n\n.nav .open>a,\n.nav .open>a:focus,\n.nav .open>a:hover {\n  border-color: #e7e7e7;\n}\n\n\n\n.navbar-default .navbar-nav>.open>a,\n.navbar-default .navbar-nav>.open>a:focus {\n  background-color: #fff;\n  background-image: none;\n  color: white;\n}\n\n.navbar-default .navbar-nav>.open>a:visited {\n  color: white;\n}\n\n\n.my-modal {\n  width: 50vw;\n}\n\n@media (max-width: 768px) {\n  .my-modal {\n    width: 80vw;\n  }\n}\n\n.staff-col {\n  margin-right: 20px;\n}\n\n.modal-footer {\n  text-align: left;\n}\n\n.modal-close-btn {\n  text-align: right;\n}\n\n.spinner {\n  position: absolute;\n  margin-left: 45%;\n  margin-top: 20%;\n}\n\n@media (max-width: 768px) {\n  .spinner {\n    margin-top: 50%;\n  }\n}\n\n.loading-overlay {\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n}\n\n.not-loading {\n  display: none;\n}\n\n.error-message {\n  color: black;\n}\n\n.error-message.modal-dialog {\n  width: 100%;\n  height: 100%;\n  margin: 0;\n  padding: 0;\n}\n\n.error-message .modal-content {\n  height: auto;\n  min-height: 100%;\n  border: 0 none;\n  border-radius: 0;\n  box-shadow: none;\n}\n\n\n.social-container {\n  display: flex;\n  flex-direction: column;\n}\n\n.social-media {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n\n.social-text {\n  padding-left: 5px;\n}\n\n\n.hide-error {\n  display: none !important;\n}\n\n.modal-open {\n  overflow: scroll !important;\n\n}\n\n@media (max-width: 576px) {\n  .modal-image {\n    width: 60px;\n    height: 60px;\n\n  }\n\n  .district-image {\n    width: 60px;\n    height: 60px;\n  }\n}\n\n.footer {\n  background-color: #1976d2;\n  color: white;\n  text-align: center;\n  padding: 20px;\n}\n\n.footer a {\n  color: white;\n  padding: 10px;\n  margin: 10px;\n}\n\n.footer a:hover {\n  text-decoration: underline;\n  text-decoration-color: black;\n}\n\n.vr {\n  color: black;\n  opacity: 1;\n}\n\n.copyright {\n  padding-top: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
